/* API Base and EndPoints */

const baseUrl = import.meta.env.VITE_REACT_APP_BASEURL;

/* App Version API's */
const appVersions = {
  get: {
    method: "GET",
    baseEndPoint: "/appV2",
    endPoint: "/versions",
  },
};

const integrations = {
  sendMail: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/integrations/send_mail",
  },
  validateAddress: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/integrations/validate_address",
  },
  sendToUW: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/integrations/send_to_uw",
  },
  testpubsub: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/integrations/pubsub/publisher",
  },
  sendMailToSecondSigner: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/integrations/send_mail_second_signer",
  },
  getIntegrations: {
    method: "GET",
    baseEndPoint: "/appV2",
    endPoint: "/integrations/get_all_integrations",
  },
  validateBankDetails: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/integrations/validate_bank_details",
  },
  validateCustomerDetails: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/integrations/validate_customer_details",
  },
  getCreditReportPDF: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/integrations/get_credit_report_pdf",
  },
  getCreditReportXML: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/integrations/get_credit_report_xml",
  },
  createApptivo: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/integrations/create_apptivo",
  },
  sendMailBulk: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/integrations/send_mail_bulk",
  },
  generateUrlIso: {
    method: "GET",
    baseEndPoint: "/appV2",
    endPoint: "/integrations/generate_url_iso",
  },
  bankNameByRoutingNo:{
    method:"GET",
    baseEndPoint:"/appV2",
    endPoint:"/integrations/bank_name_by_routing_number",
  },
  saveBankRouting:{
    method:"POST",
    baseEndPoint:"/appV2",
    endPoint:"/integrations/save_bank_routing",
  },
};

const merchant = {
  getMerchantAppById: {
    method: "GET",
    baseEndPoint: "/appV2",
    endPoint: "/merchant/get_merchant_app_by_id",
  },
  updateMerchantApp: {
    method: "PATCH",
    baseEndPoint: "/appV2",
    endPoint: "/merchant/update_merchant_app",
  },
  embeddSignMerchantApp: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/merchant/embedd_sign_merchant_app",
  },
  getDocusignAccessToken: {
    method: "GET",
    baseEndPoint: "/appV2",
    endPoint: "/merchant/docusign_access_token",
  },
  uploadDocument: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/merchant/upload",
  },
  updateMerchantAppDocuments: {
    method: "PATCH",
    baseEndPoint: "/appV2",
    endPoint: "/merchant/update_merchant_app_documents",
  },
  getAccessToken: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/merchant/create_token",
  },
  createMerchantApp: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/merchant/save_merchant_app",
  },
  updateMerchantAppMerchantEditFlag: {
    method: "PATCH",
    baseEndPoint: "/appV2",
    endPoint: "/merchant/update_merchant_edit_flag",
  },
  updateMerchantAppStatus: {
    method: "PATCH",
    baseEndPoint: "/appV2",
    endPoint: "/merchant/update_merchant_app_status",
  },
  // sendMailToRM: {
  //   method: 'POST',
  //   baseEndPoint: '/appV2',
  //   endPoint: '/merchant/send_mail_to_rm'
  // },
  sendMailToRMPartner: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/merchant/send_mail_to_rm_partner",
  },
  updateEncryptionData: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/merchant/save_encrypted_data",
  },
  verifyToken: {
    method: "GET",
    baseEndPoint: "/appV2",
    endPoint: "/merchant/verify_token",
  },
  duplicateMerchantApp: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/merchant/duplicate_merchant_app",
  },
  getSignerViewRequest: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/merchant/get_signer_view_request",
  },
  updateMerchantAppSigningStatus: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/merchant/update_merchant_app_signing_status",
  },
  updateMerchantAppStatusBulk: {
    method: "PATCH",
    baseEndPoint: "/appV2",
    endPoint: "/merchant/update_merchant_app_status_bulk",
  },
};

const merchantAppData = {
  getMerchantAppById: {
    method: "GET",
    baseEndPoint: "/appV2",
    endPoint: "/merchantapps/get_merchant_app",
  },
  getParentMerchantAppById: {
    method: "GET",
    baseEndPoint: "/appV2",
    endPoint: "/merchantapps/get_parent_merchant_app",
  },
  listMerchantApps: {
    method: "GET",
    baseEndPoint: "/appV2",
    endPoint: "/merchantapps/list_merchant_apps",
  },
  saveMerchantApp: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/merchantapps/save_merchant_app",
  },
  updateMerchantApp: {
    method: "PATCH",
    baseEndPoint: "/appV2",
    endPoint: "/merchantapps/update_merchant_app",
  },
  uploadDocument: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/merchantapps/upload",
  },
  updateMerchantAppDocuments: {
    method: "PATCH",
    baseEndPoint: "/appV2",
    endPoint: "/merchantapps/update_merchant_app_documents",
  },
  updateMerchantAppStatus: {
    method: "PATCH",
    baseEndPoint: "/appV2",
    endPoint: "/merchantapps/update_merchant_app_status",
  },
  duplicateMerchantApp: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/merchantapps/copy_merchant_app",
  },
  updateMerchantAppMiscStatus: {
    method: "PATCH",
    baseEndPoint: "/appV2",
    endPoint: "/merchantapps/update_misc_section_status",
  },
  deleteMerchantApp: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/merchantapps/delete_merchant_app",
  },
  getMerchantAppLogsById: {
    method: "GET",
    baseEndPoint: "/appV2",
    endPoint: "/merchantapps/get_merchant_app_logs",
  },
  updateOfflineAppStatus: {
    method: "PATCH",
    baseEndPoint: "/appV2",
    endPoint: "/merchantapps/update_offline_app_status",
  },
  updateSignedAppDocs: {
    method: "PATCH",
    baseEndPoint: "/appV2",
    endPoint: "/merchantapps/update_signed_app_documents",
  },
  updateMerchantAppArchivedStatus: {
    method: "PATCH",
    baseEndPoint: "/appV2",
    endPoint: "/merchantapps/update_merchant_app_archived_status",
  },
  updateMerchantAppArchivedStatusBulk: {
    method: "PATCH",
    baseEndPoint: "/appV2",
    endPoint: "/merchantapps/update_merchant_app_archived_status_bulk",
  },
};

const processorData = {
  getProcessors: {
    method: "GET",
    baseEndPoint: "/appV2",
    endPoint: "/processor",
  },
  getProcessorsUnprotected: {
    method: "GET",
    baseEndPoint: "/appV2",
    endPoint: "/processor/merchant",
  },
};

const rm = {
  listPartnersForRM: {
    method: "GET",
    baseEndPoint: "/appV2",
    endPoint: "/rm/list_partners",
  },
  listPartnersForSA: {
    method: "GET",
    baseEndPoint: "/appV2",
    endPoint: "/rm/list_partners_all",
  },
};

const partnerUsrRoles = {
  listRmsByPartnerId: {
    method: "GET",
    baseEndPoint: "/appV2",
    endPoint: "/partner_usr_roles/list_rms_by_partnerid",
  },
};

const businessDetailsDropdownData = {
  getDropdowns: {
    method: "GET",
    baseEndPoint: "/appV2",
    endPoint: "/business_dropdowns/get_all",
  },
};
const audit = {
  getAllAuditHistory: {
    method: "GET",
    baseEndPoint: "/appV2",
    endPoint: "/audit/get_all_audit_history",
  },
  getUserAuditHistory: {
    method: "GET",
    baseEndPoint: "/appV2",
    endPoint: "/audit/get_user_audit_history",
  },
  getOfficeAuditHistory: {
    method: "GET",
    baseEndPoint: "/appV2",
    endPoint: "/audit/get_office_audit_history",
  },
};
const users = {
  getByUserId: {
    method: "GET",
    baseEndPoint: "/appV2",
    endPoint: "/users/get_by_user_id",
  },
  getByDefaultRm: {
    method: "GET",
    baseEndPoint: "/appV2",
    endPoint: "/users/get_by_user_default_rm",
  },
  getByPartnerId: {
    method: "GET",
    baseEndPoint: "/appV2",
    endPoint: "/users/get_by_partner_id",
  },
  getByGUID: {
    method: "GET",
    baseEndPoint: "/appV2",
    endPoint: "/users/get_by_guid",
  },
  fetchAllUsers: {
    method: "GET",
    baseEndPoint: "/appV2",
    endPoint: "/users/get_all_users",
  },
  getRmUsers: {
    method: "GET",
    baseEndPoint: "/appV2",
    endPoint: "/users/get_rm_users",
  },
  createUser: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/users/create_user",
  },
  updateUser: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/users/update_user",
  },
  deleteUser: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/users/delete_user",
  },
  fetchUsersByRole: {
    method: "GET",
    baseEndPoint: "/appV2",
    endPoint: "/users/fetch_users_by_role",
  },
  fetchPartnersByOfficeId: {
    method: "GET",
    baseEndPoint: "/appV2",
    endPoint: "/users/fetch_partners_by_office_id",
  },
  enableIRISAccess: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/users/enable_iris_access",
  },
  enableFeenavigatorAccess: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/users/enable_feenavigator_access",
  },
 enableFreeEquipmentPlacementSubmission: {
    method: 'POST',
    baseEndPoint: '/appV2',
    endPoint: '/users/enable_free_equipment_placement'
  },

  forgotUserPassword: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/users/forgot_user_password",
  },
  resetUserPassword: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/users/reset_user_password",
  },
  sendOTP: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/users/send_otp",
  },
  verifyOTP: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/users/verify_otp",
  },
  deactivateUser: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/users/deactivate_user",
  },
  activateUser: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/users/activate_user",
  },
  resetUserPasswordBulk: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/users/reset_user_password_bulk",
  },
  deactivateUserBulk: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/users/deactivate_user_bulk",
  },
  activateUserBulk: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/users/activate_user_bulk",
  },
  getOfficeDetails: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/users/get_office_details",
  },
};

const saveLinks = {
  getSaveLinks: {
    method: "GET",
    baseEndPoint: "/appV2",
    endPoint: "/savelinks/get_all",
  },
  createSaveLink: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/savelinks/create_save_link",
  },
  getSaveLink: {
    method: "GET",
    baseEndPoint: "/appV2",
    endPoint: "/savelinks/get_one",
  },
  copySaveLink: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/savelinks/copy_save_link",
  },
  updateSaveLink: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/savelinks/update_save_link_status",
  },
  deleteSaveLink: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/savelinks/update_delete_link_status",
  },
  upateSaveLinkPatch: {
    method: "PATCH",
    baseEndPoint: "/appV2",
    endPoint: "/savelinks",
  },
  updateNumberOfClicks: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/update_no_of_clicks",
  },
  updateSaveLinkBulk: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/savelinks/update_save_link_status_bulk",
  },
  deleteSaveLinkBulk: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/savelinks/update_delete_link_status_bulk",
  },
};

const lookupData = {
  getAllLookupData: {
    method: "GET",
    baseEndPoint: "/appV2",
    endPoint: "/lookup_data/get_all",
  },
  getAllLookupDataUnprotected: {
    method: "GET",
    baseEndPoint: "/appV2",
    endPoint: "/lookup_data/get_all/merchant",
  },
  getLookupDataByType: {
    method: "GET",
    baseEndPoint: "/appV2",
    endPoint: "/lookup_data/get_by_type",
  },
  postLookupAddNewField: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/lookup_data/add_new_field",
  },
  postLookupUpdateField: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/lookup_data/update_field",
  },
  postLookupDeleteField: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/lookup_data/delete_field",
  },
};

const offices = {
  getAllOffices: {
    method: "GET",
    baseEndPoint: "/appV2",
    endPoint: "/office/get_all_offices",
  },
  getOfficesByUserId: {
    method: "GET",
    baseEndPoint: "/appV2",
    endPoint: "/office/get_office_by_office_id",
  },
  getOfficeDetails: {
    method: "GET",
    baseEndPoint: "/appV2",
    endPoint: "/office/get_office_details",
  },
  createOffice: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/office/create",
  },
  deleteOffice: {
    method: "PATCH",
    baseEndPoint: "/appV2",
    endPoint: "/office/delete",
  },
  updateOffice: {
    method: "PATCH",
    baseEndPoint: "/appV2",
    endPoint: "/office/update",
  },
  getParentChildOfficesDetailsByOfficeId: {
    method: "GET",
    baseEndPoint: "/appV2",
    endPoint: "/office/get_parent_child_offices_details",
  },
  enablePaperAppSubmission: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/office/enable_paperapps",
  },
  enableFreeEquipmentPlacementSubmission: {
    method: 'POST',
    baseEndPoint: '/appV2',
    endPoint: '/office/enable_free_equipment_placement'
  },
  deactivate: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/office/deactivate",
  },
  activate: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/office/activate",
  },
  deactivateOfficeBulk: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/office/deactivate_bulk_office",
  },
  activateOfficeBulk: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/office/activate_bulk_office",
  },
  enablePaperAppBulkSubmission: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/office/enable_bulk_paperapps",
  },
  bulkAddBanks: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/office/bulk_add_banks",
  },
  bulkAddRMs: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/office/bulk_add_rms",
  },
  getOfficesForRMSwap: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/office/get_offices_for_rm_swap",
  },
  bulkChangeRM: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/office/bulk_change_rm",
  },
};

const config = {
  getConfigData: {
    method: "GET",
    baseEndPoint: "/appV2",
    endPoint: "/clients/config",
  },
};

const superuser = {
  getAccessibleClientList: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/client_superuser/access_clients",
  },
  getSuperUserAccess : {
    method: 'POST',
    baseEndPoint: '/appV2',
    endPoint: '/client_superuser/superuser_access'
  },
  removeSuperUserAccess : {
    method: 'POST',
    baseEndPoint: '/appV2',
    endPoint: '/client_superuser/remove_superuser_access'
  }  
};

const platformAdmin = {
  getClients: {
    method: "GET",
    baseEndPoint: "/appV2",
    endPoint: "/clients",
  },
  createClient: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/clients",
  },
  updateClient: {
    method: "PATCH",
    baseEndPoint: "/appV2",
    endPoint: "/clients",
  },
  activateClient: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/clients/activate",
  },
  deactivateClient: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/clients/deactivate",
  },
  deleteClient: {
    method: "DELETE",
    baseEndPoint: "/appV2",
    endPoint: "/clients",
  },
  getAccessibleSuperUserList : {
    method: 'GET',
    baseEndPoint: '/appV2',
    endPoint: '/client_superuser/list_superusers'
  },
  getUsersList: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/client_superuser/list_users_by_role",
  },
  addSuperUserAccess: {
    method: "POST",
    baseEndPoint: "/appV2",
    endPoint: "/client_superuser/create_superuser_access",
  },
  removeSuperUser : {
    method: 'POST',
    baseEndPoint: '/appV2',
    endPoint: '/client_superuser/remove_superuser'
  },

}

const stripeCheckout = {
  getApp: { method: "GET", baseEndPoint: "/appV2", endPoint: "/stripe-checkout/app" },
  setup: { method: "POST", baseEndPoint: "/appV2", endPoint: "/stripe-checkout/setup" },
  updateSettings: { method: "PATCH", baseEndPoint: "/appV2", endPoint: "/stripe-checkout/settings" },
  emailLink: { method: "POST", baseEndPoint: "/appV2", endPoint: "/stripe-checkout/connect-link/email" },
  refresh: { method: "POST", baseEndPoint: "/appV2", endPoint: "/stripe-checkout/refresh" },
  disconnect: { method: "POST", baseEndPoint: "/appV2", endPoint: "/stripe-checkout/disconnect" },
  orders: { method: "GET", baseEndPoint: "/appV2", endPoint: "/stripe-checkout/orders" },
  statuses: { method: "GET", baseEndPoint: "/appV2", endPoint: "/stripe-checkout/statuses" },
}

const api = {
  baseUrl,
  appVersions,
  integrations,
  merchant,
  merchantAppData,
  processorData,
  rm,
  users,
  saveLinks,
  businessDetailsDropdownData,
  lookupData,
  offices,
  audit,
  config,
  partnerUsrRoles,
  superuser,
  platformAdmin,
  stripeCheckout,
};

export default api;
